const case1 = {
  "title": "Document non validé",
  "text": "Le document n'est pas complet à 100% et n'a pas été validé par un manager. Vous ne pouvez pas l'envoyer par LRE.",
  "question": "",
  "cancelLabel": "Retour au document",
  "confirmLabel": "Créer une tâche de validation"
}

const case2 = {
  "title": "Document non validé",
  "text": "Vous ne pouvez pas envoyer le document  par LRE car le document n'est pas complet à 100% et n'a pas été validé par un manager.",
  "question": "",
  "cancelLabel": "Retour au document",
  "confirmLabel": "Ouvrir le mode révision"
}

const case3 = {
  "title": "Document non complet",
  "text": "Le document n'est pas complet, veuillez le compléter avant de l'envoyer par LRE.",
  "question": "",
  "cancelLabel": "Retour au document",
  "confirmLabel": "Continuer l'envoi"
}

const case4 = {
  "title": "Document non validé",
  "text": "Le document n'est pas complet à 100% et la tâche de validation n'a pas encore été validée par le manager.\nEnvoyer quand-même le document par LRE ?",
  "question": "",
  "cancelLabel": "Retour au document",
  "confirmLabel": "Continuer l'envoi"
}

const case5 = {
  "title": "Document non validé",
  "text": "Vous ne pouvez pas envoyer le document par LRE car le document n'a pas été validé par un manager.",
  "question": "",
  "cancelLabel": "Retour au document",
  "confirmLabel": "Créer une tâche de validation"
}

const case6 = {
  "title": "Document non validé",
  "text": "Vous ne pouvez pas envoyer le document par LRE car le document n'est pas encore validé par un manager.",
  "question": "",
  "cancelLabel": "Retour au document",
  "confirmLabel": "Ouvrir le mode révision"
}

const case7 = {
  "title": "Document non validé",
  "text": "Le document n'a pas encore été validé par le manager.\nEnvoyer quand-même le document par LRE ?",
  "question": "",
  "cancelLabel": "Retour au document",
  "confirmLabel": "Continuer l'envoi"
}

const content = {
  "nonValidator": {
    "required": {
      "notValidatedNoTask": {
        "notCompleted": case1,
        "completed": case5,
      },
      "notValidatedTask": {
        "notCompleted": case2,
        "completed": case6,
      },
      "validated": {
        "notCompleted": case3
      }
    },
    "optional": {
      "notValidatedNoTask": {
        "notCompleted": case3
      },
      "notValidatedTask": {
        "notCompleted": case4,
        "completed": case7,
      },
      "validated": {
        "notCompleted": case3
      }
    }
  },
  "validator": {
    "required": {
      "notValidatedNoTask": {
        "notCompleted": case3,
      },
      "notValidatedTask": {
        "notCompleted": case4,
        "completed": case7,
      },
      "validated": {
        "notCompleted": case3
      }
    },
    "optional": {
      "notValidatedNoTask": {
        "notCompleted": case3
      },
      "notValidatedTask": {
        "notCompleted": case4,
        "completed": case7,
      },
      "validated": {
        "notCompleted": case3
      }
    }
  }
}

export default content
